const aftersaleApiList = {
  // http://test-diablo.ruigushop.com/system/as_order/statusenum?shop_id=40
  asOrderStatus: "/enum/asOrderStatus", // 售后单状态
  asOrderStatusEnum: "/system/as_order/statusenum", // 售后单状态(新状态接口 - 工厂|直发用)
  asOrderType: "/enum/asOrderType", // 售后单类型
  asDeliveryPayer: "/enum/asDeliveryPayer", // 售后单运费承担方
  aftersaleList: "/aftersales/external/order/list", // 售后单列表
  aftersaleDetail: "/aftersales/external/order/detail", // 售后单明细
  //acceptRefund: '/aftersales/external/order/acceptRefund', // 售后确认接受退款(退货) (原接口)
  acceptRefund: "/v3/manage/aftersale/confirm", // 售后确认接受退款(退货) （R4 售后重构 更换接口  2021-07-01）
  //receiptByShop: '/aftersales/external/transport/receiptByShop', // 售后收货（原接口）
  receiptByShop: "/v3/manage/aftersale/receiveGoods", // 售后收货（R4 售后重构 更换接口  2021-07-01）
  //acceptRepair: '/aftersales/external/order/acceptRepair', // 售后确认接受维修(维修) （原接口）
  acceptRepair: "/v3/manage/aftersale/confirm", // 售后确认接受维修(维修) （R4 售后重构 更换接口  2021-07-01）
  //acceptExchange: '/aftersales/external/order/acceptExchange', // 售后确认接受换货(换货)
  acceptExchange: "/v3/manage/aftersale/confirm", // 售后确认接受换货(换货) (R4 售后重构 更换接口  2021-07-01)
  closeAftersale: "/aftersales/external/order/close", // 关闭售后单
  receiptDelay: "/aftersales/external/transport/receiptDelay", // 延长商品确认
  //shippedByShop: '/aftersales/external/transport/afterSaleShipment', // 售后出库(原接口)
  shippedByShop: "/v3/manage/aftersale/deliveryGoods", // 售后出库(R4 售后重构 更换接口  2021-07-01)
  shippingList: "/aftersales/external/order/shippingList", // 直发发货清单
  AfterDeliveryList: "/aftersales/external/order/AfterDeliveryList", // 三方售后维修发货清单
  printBox: "/aftersales/external/order/printBox", // 售后打印箱码
  downLoadAfterOrder: "/aftersales/external/order/downloadApOrder", // 导出售后订单
  //getAfterListBox: '/aftersales/external/order/listBox', // 获取售后箱码（原接口）
  getAfterListBox: "/v3/manage/aftersale/getCourierDetail", // 获取售后箱码(R4 售后重构 更换接口  2021-07-01)
  getAfterCloseReason: "/aftersales/external/order/closeReason", // 获取关闭原因
  getAfterSaleNeedConfirmByReturnCount:
    "/v2/web/order/getAfterSaleNeedConfirmByReturnCount", // 获取三方待确认的售后单数量
  afterSaleConfirmByReturn: "/v2/web/order/afterSaleConfirmByReturn", // 三方售后确认（仅平台，退款类型的售后单）
  getServiceNowTime: "/v2/web/shop/getServiceNowTime", // getServiceNowTime
  saveNotSystemLogisticsByAfterSale:
    "/v2/web/order/saveNotSystemLogisticsByAfterSale", // 售后单陆屋快递
  getAfterSaleCourierList: "/v2/web/order/getAfterSaleCourierList", // 售后单录入快递单

  // bigafter
  bigaftersaleList: "/special/aftersales/order/list", // 售后单列表
  bigaftersaleDetail: "/special/aftersales/order/detailInfo", // 售后单明细
  //biggetAfterListBox: '/special/aftersales/order/viewTransferInfo', // 获取售后箱码
  biggetAfterListBox: "/v3/manage/aftersale/getCourierDetail", // 获取售后箱码(R4 售后重构 更换接口  2021-07-01)
  //bigshippedByShop: '/special/aftersales/order/maintainOutWareHouse', // 售后出库
  bigshippedByShop: "/v3/manage/aftersale/deliveryGoods", // 售后出库 (R4 售后重构 更换接口  2021-07-01)
  bigshippingList: "/special/aftersales/order/outWareHouseList", // 直发发货清单
  getNewList: "/system/as_order/list", //售后订单列表（直发|工厂专用 2022-11-16新增）
  getBoxStatus: "/system/as_order/boxstatusenum", //物流状态枚举（直发|工厂专用 2022-11-16新增）
  getTransportList: "/system/as_order/transportlist", //售后订单包裹状态枚举（直发|工厂专用 2022-11-16新增）
  getPackagetrace: "/system/transport/astrace", //包裹对应物流轨迹
  getWorkOrderList: "/work-order-center-web/work-order-query/find-external-common-page", //售后关联工单列表（ 2023-10-10新增）
  queryPendingMsgTop: "/system/message/pendingtopten", //待处理消息Top10
  queryPendingMsg: "/system/message/pendinglist", //待处理消息
  queryTimeLine: "/system/as_order/prescriptioninfo", //售后时效
  queryStandard: "/system/as_order/productaftersalepolicy", //售后标准
  queryOrderInfo: "/system/as_order/info" //售后单信息(top10消息中缺少“售后类型”，从这个接口获取)
};
export default aftersaleApiList;



// WEBPACK FOOTER //
// ./src/service/basic/aftersaleApiList.js